import { useEffect } from 'react';

export default function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    }
    window.addEventListener('keydown', handleKeyDown);
    // Forhindr scroll af baggrunden, når lightbox er åben
    document.body.style.overflow = 'hidden';
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [onClose, onPrev, onNext]);

  if (currentIndex === null || !images || images.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4 md:p-8 backdrop-blur-xs">
      {/* Luk-knap */}
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 text-white/80 hover:text-white text-3xl p-2 cursor-pointer focus:outline-none z-50 hover:scale-110 transition-transform"
        aria-label="Luk galleri"
      >
        <i className="fa-solid fa-xmark" />
      </button>

      {/* Forrige-knap */}
      {images.length > 1 && (
        <button 
          onClick={onPrev}
          className="absolute left-4 md:left-8 text-white/80 hover:text-white text-3xl md:text-4xl p-3 cursor-pointer focus:outline-none z-50 hover:scale-110 transition-transform bg-black/40 hover:bg-black/60 rounded-full w-12 h-12 md:w-16 md:h-16 flex items-center justify-center"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left" />
        </button>
      )}

      {/* Billede container */}
      <div className="relative max-w-5xl max-h-[85vh] flex flex-col items-center justify-center">
        <img 
          src={images[currentIndex]} 
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl select-none"
        />
        <div className="text-white/60 text-sm mt-4 font-medium">
          Billede {currentIndex + 1} af {images.length}
        </div>
      </div>

      {/* Næste-knap */}
      {images.length > 1 && (
        <button 
          onClick={onNext}
          className="absolute right-4 md:right-8 text-white/80 hover:text-white text-3xl md:text-4xl p-3 cursor-pointer focus:outline-none z-50 hover:scale-110 transition-transform bg-black/40 hover:bg-black/60 rounded-full w-12 h-12 md:w-16 md:h-16 flex items-center justify-center"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right" />
        </button>
      )}
    </div>
  );
}
